export const capitalize = (str: string) =>
  (str.charAt(0).toUpperCase() + str.slice(1)).replace(/-/g, " ");

export const limitLengthWithEllipsis = (
  value: string,
  length: number
): string => {
  if (value.length > length) {
    return value.substring(0, length) + "...";
  }
  return value;
};

export const hasSpaces = (str: string): boolean => {
  return str.includes(" ");
};

export const isWebLink = (str: string): boolean => {
  return !!str && str.toLowerCase().startsWith("http");
};

const whitespaceRegex = new RegExp(/^\s*$/);

export const isNullOrEmptyOrWhitespace = (
  str: string | undefined | null
): boolean => {
  return !str || whitespaceRegex.test(str);
};

export const containsMarkdownLink = (text: string): boolean => {
  const regExx = /(?<!\\)\[([^\]]+)\]\(([^)]+)\)/g;

  return regExx.test(text);
};

/**
 * Converts a number to two decimal places string. Eg: converts 10 to "10.00"
 * @param num number. example 10
 * @returns two decimal place string. example "10.00"
 */
export const convertToTwoDecimalPlaces = (
  num: number | undefined | null
): string => {
  if (num === undefined || num === null) {
    return "-";
  }
  return (Math.round(num * 100) / 100).toFixed(2);
};

/**
 * Formats a number to include commas for thousands. Eg: converts 10000 to "10,000".
 * @remarks This will work on any number inside a string. Eg: "$1000 to $1200" becomes "$1,000 to $1,200".
 * @param value The string or number containing to format.
 */
export const formatThousands = (value: string | number | null | undefined) => {
  if (value === undefined || value === null) return "";
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
